import React from 'react';
import PropTypes from "prop-types";
import { bindActionCreators } from 'redux';
import { connect } from "react-redux";
import { withTranslation } from 'react-i18next';
import styled from 'styled-components';

import { setViewTab } from '../../actions/ui';
import {
  getSizesProfileList,
  selectSizeProfile,
  changeSizeScenario,
  changeSizeActiveTab,
} from '../../actions/sizes';

import {
  getSortedShirtProfiles,
  getLoginState
} from '../../selectors/entities/users';
import { getSizesProfile } from '../../selectors/entities/general';

import { Menu, MenuItem } from '../ui/Menu';
import Attr from "../ui/Attr/Attr";
import { Toggle } from '../ui/Toggle';

import SmartMark from "../Sizes/SmartMark";
import SelectSavedSizes from '../Sizes/SelectSavedSizes';
import SmartSizeForm from "../FormSmartSize";
import StandartSizeForm from "../FormStandartSize";
import MeasureSizeForm from "../FormMeasureSize";
import ClearIcon from '../../components/icons/ClearIcon';

import MeasureForSmartOptions from './measuresFromSmartOptions';
import MeasureForTableOptions from './measuresFromTableOptions';

const MenuWrapper = styled.section`
  margin: 10px 20px;
`;

class BuilderSize extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      openAttr: false,
      selectedAttr: '',
      sectionName: '',
      openPopup: false,
    }
  }

  getSize = (sizeTypes) => sizeTypes[this.state.selectedAttr]

  selectAttrTop = (event, value) => {
    this.setState({ openAttr: true, selectedAttr: value })
    this.props.sizeActions.changeSizeActiveTab(value)
  }

  selectAttr = (value) => {
    this.setState({ openAttr: true, selectedAttr: value })
    this.props.sizeActions.changeSizeActiveTab(value)
  }

  closeAttr = () => {
    this.setState({ openAttr: false, selectedAttr: false })
    this.props.sizeActions.changeSizeActiveTab('')
  }


  onSmartMarkClick = () => {
    const attr = 'smart';
    this.setState({
      selectedAttr: attr,
      openAttr: true,
    })
    this.props.sizeActions.changeSizeActiveTab(attr)
  }

  openPopup = () => {
    return this.state.selectedAttr === 'measure'
  }

  closePopup = () => {
    this.setState({ selectedAttr: false })
    this.props.sizeActions.changeSizeActiveTab('')
  }


  renderMobileMenu = (toggles) => (
    <div className={'mobile-menu'}>
      <div className={'mobile-menu-wrapper'}>
        <Toggle
          value={this.state.selectedAttr}
          className="toggle"
          block={false}
          equalWidth={false}
          variation={'center'}
          onChange={this.selectAttrTop}
        >
          {toggles}
        </Toggle>
      </div>
    </div>
  )

  makeRenderSection = (attr) => {
    return attr ? this.sizeTypeParams[attr].section : null;
  }


  onSizeProfileSelect = (profile) => {
    this.props.sizeActions.selectSizeProfile(profile)
    this.props.sizeActions.changeSizeScenario('profile')
  }

  componentDidMount = async () => {
    await this.props.sizeActions.getSizesProfileList();
  }


  onLogin = () => {
    const button = document.getElementById('enter-link');
    if (button) {
      button.click();
    }
  }

  getCurrentAttrText = selectedAttr => {
    return selectedAttr === 'smart' ? 'Умная мерка' :
      selectedAttr === 'measure' ? 'Снять размеры с тела' :
        selectedAttr === 'standart' ? 'Стандартные размеры' : 'Размеры'
  }

  onAfterMeasureSubmit = async () => {
    this.closeAttr();

    const {
      uiActions: { setViewTab },
    } = this.props;

    //если пользователен не в авторизован, то переходим на следующую вкладку
    //постановка задачи от Натальи Мельниковой

    ///Как оказалось в последствии это касается и не авторизованных пользователей. от 03.12.2020
    setViewTab(3);
    return;
  }

  render() {

    const {
      isLogined,
      shirtProfiles,
      selectedProfile,
      isMobile,
    } = this.props;

    const { selectedAttr, openAttr } = this.state
    const currentText = this.getCurrentAttrText(selectedAttr);

    let main = (
      <SmartMark
        onClick={this.onSmartMarkClick}
        isMobile={isMobile}
      />
    )
    if (isLogined) {
      main = (
        <SelectSavedSizes
          shirtProfiles={shirtProfiles}
          onSizeSelect={this.onSizeProfileSelect}
          value={selectedProfile}
          defaultText='Профиль размеров'
        />
      )
    };


    let menu = (
      <MenuWrapper>
        <Menu value={selectedAttr} onChange={this.selectAttr}>
          {isLogined &&
            <MenuItem
              className='config-options-wrapper__menu-item item_sizes'
              onClick={this.onSmartMarkClick}
              value={'smart'}
            >
              Умная мерка
          </MenuItem>
          }
          <MenuItem
            className='config-options-wrapper__menu-item item_sizes'
            onClick={this.onMenuClick}
            value={'measure'}
          >
            Снять размеры с тела
          </MenuItem>
          <MenuItem
            className='config-options-wrapper__menu-item item_sizes'
            onClick={this.onMenuClick}
            value='standart'
          >
            Стандартные размеры
          </MenuItem>
        </Menu>
      </MenuWrapper>
    )

    let content = null;
    if (!selectedAttr) {
      content = (
        <div
          className='config-options-wrapper__attr config-options-wrapper__size-attr'
        >
          <section>
            {!isMobile && <h3 className='config-options-wrapper__size-section-header'>
              {isLogined ? 'ВЫБРАТЬ РАЗМЕРЫ' : 'СОЗДАТЬ РАЗМЕРЫ'}
            </h3>}
            {main}
          </section>
          <section>
            {isLogined && !isMobile &&
              <h3 className='config-options-wrapper__size-section-header'>
                СОЗДАТЬ РАЗМЕРЫ
            </h3>}
            {menu}
          </section>
        </div>
      )
    } else {
      content = (
        <Attr
          closeOnEsc={false}
          showClose={!isMobile}
          isOpened={openAttr}
          backdropColor="black"
          onRequestClose={this.closeAttr}
        >
          {!isMobile &&
            <div className='config-header'>
              {currentText}
            </div>
          }
          {selectedAttr == 'smart' &&
            <div className='b-rit-section'>
              <SmartSizeForm />
              <MeasureSizeForm
                hideInfo={true}
                containExpertMode={false}
                sizeOptions={MeasureForSmartOptions}
                onAfterSubmit={this.onAfterMeasureSubmit}
                // closeAttr={this.closeAttr}
              />
            </div>
          }
          {selectedAttr == 'measure' &&
            <div className='b-rit-section'>
              <MeasureSizeForm
                hideInfo={false}
                containExpertMode={true}
                sizeOptions={MeasureForTableOptions}
                onAfterSubmit={this.onAfterMeasureSubmit}
                // closeAttr={this.closeAttr}
              />
            </div>
          }
          {selectedAttr == 'standart' &&
            <StandartSizeForm
              onAfterSubmit={this.onAfterMeasureSubmit}
              // closeAttr={this.closeAttr}
              buttonSize={'30em'}
            />
          }
        </Attr>
      )
    }


    let mobileHeader = null;
    if (isMobile) {
	    if (!isLogined) {
      mobileHeader = (
        <div
          className='fabric-builder__header'
          style={{ padding: '25px 25px 0' }}
        >
          <p
            className='fabric-builder__title'
            style={{ padding: '6px 0' }}
          >
            {currentText}
          </p>
          {
            !openAttr ?
              <div className="fabric-builder__login-wrapper">
                <div className="fabric-builder__login-label">
                  Уже есть профиль размеров?
              </div>
                <button
                  className="fabric-builder__login-button"
                  onClick={this.onLogin}
                >
                  Войти
              </button>
              </div> :
              <ClearIcon
                style={{ width: '14px', height: '14px' }}
                onClick={this.closeAttr}
              />
          }
        </div>
      )
     } else {
        mobileHeader = (
          <div
            className='fabric-builder__header'
            style={{ padding: '25px 25px 0' }}
          >
          <p
            className='fabric-builder__title'
            style={{ padding: '6px 0' }}
          >
            {currentText}
          </p>
          {
            !openAttr ?
              <div className="fabric-builder__login-wrapper">
                <div className="fabric-builder__login-label"></div>
              </div> :
	      <ClearIcon
	      style={{ width: '14px', height: '14px' }}
	      onClick={this.closeAttr}
	      />
	  }
	  </div>
	)
     }
    }

    return (
      <section className="config-options-wrapper">
        {mobileHeader}
        {content}
      </section>
    );
  }
}

BuilderSize.propTypes = {
  selectedProfile: PropTypes.object.isRequired,
  shirtProfiles: PropTypes.array.isRequired,
  isLogined: PropTypes.bool.isRequired,
  setViewTab: PropTypes.object,
  isMobile: PropTypes.bool.isRequired,
  sizeActions: PropTypes.object.isRequired,
  sizeActiveTab: PropTypes.string,
};

function mapStateToProps(state) {
  const selectedProfile = getSizesProfile(state);
  const shirtProfiles = getSortedShirtProfiles(state);
  const isLogined = getLoginState(state);
  const isMobile = state.ui.isMobile;
  const sizeActiveTab = state.general.updateSize.sizeActiveTab;

  return {
    selectedProfile,
    shirtProfiles,
    isLogined,
    isMobile,
    sizeActiveTab,
  };
}


function mapDispatchToProps(dispatch) {
  return {
    uiActions: bindActionCreators({ setViewTab }, dispatch),
    sizeActions: bindActionCreators({
      getSizesProfileList,
      selectSizeProfile,
      changeSizeScenario,
      changeSizeActiveTab,
    },
      dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(BuilderSize));
